/**
 * Category landing page — Field Data hub.
 *
 * Surfaces the staff-team tools (lawn signs + volunteers). Each tool's
 * route still enforces its own paywall via ProtectedRoute — this page
 * is navigation-only.
 */
import { Link } from "react-router-dom";
import { ArrowLeft, Flag, UsersRound } from "lucide-react";
import { ToolGrid } from "./Communications";

const TOOLS = [
  {
    to: "/lawn-signs",
    title: "Lawn Sign Tracker",
    blurb: "Log every sign you put out, who hosts it, and when to retrieve it.",
    icon: Flag,
    tone: "red",
    testid: "field-lawn-signs",
  },
  {
    to: "/volunteers",
    title: "Volunteer Database",
    blurb: "Track volunteers, their skills, availability, and last contact in one place.",
    icon: UsersRound,
    tone: "navy",
    testid: "field-volunteers",
  },
];

export default function FieldData() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10" data-testid="page-field-data">
      <Link to="/dashboard" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-600 hover:text-flag-navy">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>
      <div className="mt-4">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-flag-red">Field Data</p>
        <h1 className="font-display text-3xl sm:text-4xl font-black text-flag-navy mt-1">Run the ground game.</h1>
        <p className="text-slate-600 mt-2 max-w-2xl text-base">The on-the-ground operations log — yard signs out the door, volunteers in the field, nothing slipping through the cracks.</p>
      </div>
      <ToolGrid tools={TOOLS} />
    </div>
  );
}
